
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(2(13|2|3)|[03]88|139)|2(110|244|280|333|658|773)|5(7(14|36|76)|9(07|18|47)|(14|22|56)8)|6(3(07|09|82)|[78]57|418|612|936)|1((1|26|42)4|233|471|502|582|839|923|960)|8(9(35|8|95)|007|065|452|486|878)|7((03|10|34)0|187|332|681|911|936)|3((51|58|72)9|044|266|405|785|936|994)|9(8(08|15|61)|288|37|431|475|554|724|993))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
